import { Flex, Image, Tooltip } from "antd";
import Paragraph from "antd/es/typography/Paragraph";
import { useTranslation } from "react-i18next";
import Profile from "../../../../member/profile";
import { ecType } from "./ec.types";
import { memberType } from "../../../../../types/member";
import React from "react";
import Navbar from "../../../../../components/Navbar";
import info from "../../../../../assets/icons/info.svg";
import { hexToRgba } from "../../../../../utils/useColor";

type MemberPreviewProps = {
  data: ecType;
  platform: string;
};

const MemberPreview: React.FC<MemberPreviewProps> = ({
  data,
  platform,
}: MemberPreviewProps) => {
  const { t } = useTranslation();
  const extraMemberData: Pick<
    memberType,
    | "id"
    | "customer_id"
    | "name"
    | "member_level"
    | "start_date"
    | "end_date"
    | "consumption"
    | "points"
    | "coupons"
    | "credits"
    | "clerk_name"
    | "currency"
    | "store"
    | "shop_url"
    | "hide_tabs"
    | "barcode_value"
    | "maac_org_id"
    | "maac_bot_id"
    | "shop_name"
    | "platform_type"
    | "enable_custom_credits_name"
  > = {
    id: 1234567890005,
    customer_id: "1234567890005",
    name: "Member Name",
    member_level: "Membership Level",
    start_date: new Date("2024-01-01"),
    end_date: new Date("2024-12-31"),
    consumption: 0,
    points: 0,
    coupons: 0,
    credits: 0,
    currency: "NT$",
    clerk_name: "",
    store: "Store Name",
    shop_url: "",
    hide_tabs: [],
    barcode_value: "1234567890005",
    maac_org_id: 1,
    maac_bot_id: 1,
    shop_name: "Shop Name",
    platform_type: "shopify",
    enable_custom_credits_name: false,
  };
  switch (data.barcode_value_source) {
    case "phone":
      extraMemberData.barcode_value = "+886912345678";
      break;
    case "local_phone":
      extraMemberData.barcode_value = "0912345678";
      break;
    case "email":
      extraMemberData.barcode_value = "example@email.com";
      break;
  }

  if (platform === "shopify") {
    extraMemberData.member_level = null;
    extraMemberData.points = null;
    extraMemberData.coupons = null;
    extraMemberData.credits = null;
    extraMemberData.start_date = null;
    extraMemberData.end_date = null;
    extraMemberData.store = "";
    extraMemberData.hide_tabs = ["/coupon"];
  } else if (platform === "91app") {
    extraMemberData.member_level = "0";
    extraMemberData.points = null;
    extraMemberData.coupons = null;
    extraMemberData.credits = null;
    extraMemberData.hide_tabs = ["/coupon"];
  }

  // Add /order to hide_tabs if is_enabled_order is false
  if (!data.is_enabled_order && !extraMemberData.hide_tabs.includes('/order')) {
    extraMemberData.hide_tabs.push('/order');
  }

  return (
    <Flex
      vertical
      className="w-full"
      gap={"large"}
      style={
        {
          "--app-foreground-color": data.foreground_color,
          "--app-lighten-foreground-color": hexToRgba(
            data.foreground_color,
            0.25
          ),
          "--app-background-color": data.background_color,
        } as React.CSSProperties
      }
    >
      <Flex align="center" gap={"4px"}>
        <Paragraph className="h2-bold text-o-title">{t("Preview")}</Paragraph>
        <Tooltip
          title={t(
            "Preview for layout reference only. Actual display size may vary depending on the device and OS."
          )}
          color="white"
        >
          <Image src={info} preview={false} />
        </Tooltip>
      </Flex>
      <Flex
        vertical
        className="p-2 w-[346px] h-[706px] mx-auto border-2 border-neutral-300 rounded-[44px] overflow-hidden relative"
      >
        <Flex vertical className="rounded-t-[32px] overflow-hidden select-none h-full">
          <Flex
            id="ec-member-card-preview"
            vertical
            className="overflow-y-auto awesome-scrollbar h-[calc(100%)] min-h-[calc(100%-50px)] bg-[var(--app-background-color)]"
          >
            <Profile
              platform={platform}
              previewData={{
                ...extraMemberData,
                is_enabled_barcode: data.is_enabled_barcode,
                barcode_type: data.barcode_type,
                is_enabled_member_benefits: data.is_enabled_member_benefits,
                member_benefits_url: data.member_benefits_url,
                is_enabled_faq: data.is_enabled_faq,
                is_60_days_consumption: platform === "shopify",
                faq_url: data.faq_url,
                foreground_color: data.foreground_color,
                background_color: data.background_color,
                logo: data.logo_url,
                brand_name: data.brand_name,
                card_orders: [],
                card_coupons: [],
                coupon_url: null,
                is_enabled_referral: false,
                order_url: data.order_url,
                is_enabled_annual_consumption: data.is_enabled_annual_consumption,
                is_enabled_order: data.is_enabled_order,
                show_member_level: data.show_member_level,
                enable_member_level_name: data.enable_member_level_name,
                member_level_name_mapping: data.member_level_name_mapping,
                custom_credits_name_mapping: data.custom_credits_name_mapping,
                enable_custom_credits_name: data.enable_custom_credits_name,
              }}
            />
          </Flex>
        </Flex>
        <div className="absolute bottom-0 left-0 right-0 bg-white">
          <Navbar
            couponURL={null}
            preview
            hideTabs={extraMemberData.hide_tabs}
          />
        </div>
      </Flex>
    </Flex>
  );
};
export default MemberPreview;
